import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import React, { FC, ReactNode } from 'react';
import { AllNewsButton, NewsCard, NewsDescription, NewsImage, NewsWrapper, SectionContainer } from './NewsSectionStyle';
import { SectionHeadline } from '../../../styles/Common';
import { urlForImage } from '../../../utils/urlForImage';
import { LinkFieldType, NewsType } from '../../../interfaces/frontpage';

interface NewsSectionProps {
    news?: Array<NewsType>;
    allNewsLink?: LinkFieldType;
    newsTitle?: string;
    border?: boolean;
}

const NewsSection: FC<NewsSectionProps> = ({ news, allNewsLink, newsTitle, border }) => {
    const { t } = useTranslation();
    const { language } = useI18next();

    const displayNews = (): ReactNode =>
        news
            ?.filter((item: any, index: number) => index < 3 && item?.field_image?.length > 0)
            ?.map((item: any, index: number) => (
                <NewsCard key={index} to={item?.url ? `/${language}${item.url}` : '#'}>
                    <NewsImage
                        src={urlForImage(item?.field_image[0]?.field_media_image)}
                        alt={item?.field_image?.length > 0 ? item?.field_image[0]?.alt : 'news img'}
                    />
                    <NewsDescription>{item?.title}</NewsDescription>
                </NewsCard>
            ));

    return (
        <SectionContainer border={border}>
            <SectionHeadline>{newsTitle && newsTitle?.length > 0 ? newsTitle : t('news')}</SectionHeadline>
            <NewsWrapper>{displayNews()}</NewsWrapper>
            {allNewsLink?.uri && allNewsLink?.uri?.length > 0 && (
                <AllNewsButton to={`/${language}${allNewsLink.uri}`}>
                    {allNewsLink?.text && allNewsLink?.text?.length > 0 ? allNewsLink.text : t('allNews')}
                </AllNewsButton>
            )}
        </SectionContainer>
    );
};

export default NewsSection;
